import { string, object, array } from 'yup';
import { BOOKING_MAPPING } from '../../constants';
import { PriceSchema } from './CommonSchema';

const HotelBookingSchema = object().shape({
  hotel_id: string().required(),
  order_id: string().required(),
  order_number: string().required(),
  status: string().oneOf(Object.keys(BOOKING_MAPPING)).required(),
  checkin: string().required(),
  checkout: string().required(),
  rooms: array()
    .of(
      object().shape({
        room_name: string().required(),
      })
    )
    .required(),
  total_price: object().shape({
    total_exclusive_price: PriceSchema.required(),
    total_inclusive_price: PriceSchema.required(),
  }),
});

export default HotelBookingSchema;
